import React, { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import router from "./Routes";
import { CssBaseline, ThemeProvider } from "@mui/material";
import theme from "./Theme";
import toast, { Toaster } from "react-hot-toast";
import { I18nextProvider, useTranslation } from "react-i18next";
import i18n from "./i18n";
import { useLanguageStore } from "./Store/store";
import { HelmetProvider } from "react-helmet-async";

export default function App() {
  const { language } = useLanguageStore();
  const { i18n } = useTranslation();
  useEffect(() => {
    i18n.changeLanguage(language);
    document.body.dir = language == "fa" ? "rtl" : "ltr";
  }, [language]);
  return (
    <>
      <I18nextProvider i18n={i18n}>
        <HelmetProvider>
          <Toaster />
          <ThemeProvider theme={theme}>
            <CssBaseline />
            <RouterProvider router={router} />
          </ThemeProvider>
        </HelmetProvider>
      </I18nextProvider>
    </>
  );
}
